import { render } from "./NotificationsManager.vue?vue&type=template&id=23fd47cb"
import script from "./NotificationsManager.vue?vue&type=script&lang=js"
export * from "./NotificationsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__